// Frans (fr-FR), householdsApp: zelfde vorm als householdsApp.nl.ts (golf 6b). Wat ontbreekt valt
// terug op het Nederlands (nooit een rauwe sleutel op het scherm).
export const appHouseholdsFr = {
    question: 'Qui habite à la maison ?',
    questionBody: 'Nous préparons alors ce qui vous convient. Tu peux tout changer plus tard, rien ne se perd jamais.',
    types: {
        family: {
            name: 'Famille avec enfants',
            body: 'Des parents avec des enfants. Agenda, tâches avec étoiles, dépose et récupération.',
        },
        two_home: {
            name: 'Famille avec deux maisons',
            body: 'Les enfants vivent aussi en partie chez l’autre parent. Calme et neutre.',
        },
        couple: {
            name: 'Couple',
            body: 'Deux adultes. Un agenda commun, les courses et ce qu’il y a à faire.',
        },
        solo: {
            name: 'Seul·e',
            body: 'Garder le cap sur le travail, le sport et les rendez-vous. Court et clair.',
        },
        student: {
            name: 'Colocation étudiante',
            body: 'Un planning de ménage équitable, les courses et un tableau de messages. L’écran du couloir sait à qui c’est le tour de la vaisselle.',
        },
        shared: {
            name: 'Colocataires',
            body: 'Un logement partagé entre adultes. Un planning équitable et un écran dans le couloir.',
        },
        cohousing: {
            name: 'Habitat groupé ou béguinage',
            body: 'Des logements individuels avec un espace commun. Un agenda pour la salle commune, des messages et qui fait le ménage.',
        },
        senior: {
            name: 'Seniors à domicile',
            body: 'Autonomes chez soi. Grands caractères, rendez-vous, rappels (médicaments aussi) et la météo.',
        },
        care: {
            name: 'Seniors à domicile, la famille suit',
            body: 'Une personne qui vit seule, avec de la famille qui suit à distance. Grands caractères, peu de boutons.',
        },
    },
    short: {
        family: 'Famille',
        two_home: 'Famille avec deux maisons',
        couple: 'Couple',
        solo: 'Seul·e',
        student: 'Colocation étudiante',
        shared: 'Colocataires',
        cohousing: 'Habitat groupé',
        senior: 'Seniors à domicile',
        care: 'Seniors avec la famille',
    },
    /** Vervolgvraag bij Ouderen thuis (live r1): ja = care (familie kijkt mee), nee = senior. */
    seniorFamilyQuestion: 'La famille suit-elle à distance ?',
    yes: 'Oui',
    no: 'Non',
    laterNote: 'Plusieurs générations sous le même toit ? Choisissez Famille avec enfants.',
    modulesOn: 'Voici ce que nous activons pour vous',
    modulesOnHint: 'C’est bien cela ? Tu peux activer ou désactiver chaque partie plus tard dans Réglages.',
    confirm: 'C’est bon, suivant',
    settingsTitle: 'Type de foyer',
    settingsBody: 'Famille, colocataires, seul·e …',
    settingsIntro: 'Le type détermine les parties activées par défaut, l’apparence de l’appli et quelques mots. Rien n’est jamais supprimé.',
    current: 'Choisi actuellement',
    choose: 'Choisir un autre type',
    previewTitle: 'Qu’est-ce qui change ?',
    turnsOn: 'S’active',
    turnsOff: 'Se désactive',
    turnsOffNote: 'Ce qu’il contient reste enregistré. Si tu le réactives plus tard, tout est encore là.',
    kept: 'Reste comme vous l’avez choisi',
    nothingChanges: 'Les parties restent telles quelles. Seuls l’apparence et quelques mots changent.',
    lookChanges: 'L’apparence s’adapte aussi.',
    resetChoices: 'Remettre aussi nos propres choix dans Modules par défaut',
    apply: 'Passer à {name}',
    cancel: 'Ne pas changer',
    toast: 'Votre foyer est maintenant : {name}. Rien n’a été supprimé.',
    onlyParents: 'Seul un administrateur peut modifier cela.',
    words: {
        family: {
            members: 'Membres de la famille',
            profileTitle: 'Qu’est-ce qui convient à votre famille ?',
            weatherBody: 'Manteau, bottes ou crème solaire : on le dit au moment où les enfants sortent.',
            adult: 'Parent',
            tasks: 'Tâches',
            cleaning: 'Ménage',
            household: 'famille',
            admin: 'Parent',
        },
        adults: {
            members: 'Qui habite ici',
            profileTitle: 'Qu’est-ce qui vous convient ?',
            weatherBody: 'Manteau, parapluie ou crème solaire : on le dit juste avant que tu sortes.',
            adult: 'Adulte',
            tasks: 'Tâches',
            cleaning: 'Ménage',
            household: 'foyer',
            admin: 'Administrateur',
        },
        shared: {
            members: 'Colocataires',
            profileTitle: 'Qu’est-ce qui convient à votre maison ?',
            weatherBody: 'Manteau, parapluie ou crème solaire : sur l’écran de l’entrée, juste avant que tu sortes.',
            adult: 'Colocataire',
            tasks: 'Tâches',
            cleaning: 'Ménage',
            household: 'maison',
            admin: 'Administrateur',
        },
        care: {
            members: 'Famille',
            profileTitle: 'Qu’est-ce qui vous convient ?',
            weatherBody: 'Manteau, parapluie ou crème solaire : on le dit juste avant que tu sortes.',
            adult: 'Adulte',
            tasks: 'Tâches',
            cleaning: 'Ménage',
            household: 'foyer',
            admin: 'Aidant',
        },
    },
    greetingHouse: 'Content de te voir',
    wizardRotationTitle: 'Un planning équitable',
    wizardRotationBody: 'Cuisine, salle de bain, couloir, poubelles et vaisselle tournent chaque semaine, et chaque soir quelqu’un d’autre cuisine. L’écran de l’entrée montre à qui c’est le tour.',
    wizardAdultsTitle: 'Prêt à commencer',
    wizardAdultsBody: 'Mets tes rendez-vous dans l’agenda et garde un œil sur ce qu’il y a à faire. Ton téléphone te fait signe quand c’est utile.',
    wizardMembersShared: 'Qui habite la maison ? Tu pourras donner plus tard à chacun son propre accès.',
    /** Golf 6b fixer r1: woorden bij "alleen" (enkelvoud; de rest van de volwassen set blijft). */
    soloWords: {
        members: 'Qui en fait partie',
        profileTitle: 'Qu’est-ce qui te convient ?',
        profileBody: 'Choisis cuisine, religion et alimentation, et tu verras surtout ce qui te convient. Ce n’est pas obligatoire.',
    },
    /** Live r1: woorden bij een woongroep of hofje (bovenop de volwassen set). */
    cohousingWords: {
        members: 'Habitants',
        profileTitle: 'Qu’est-ce qui convient à votre habitat groupé ?',
        household: 'habitat groupé',
        adult: 'Habitant',
    },
    /** Golf 6b fixer r1: toon per soort (geen kindertaal bij volwassen soorten; gezin = standaard). */
    tone: {
        adults: {
            membersTitle: 'Qui habite ici',
            membersIntro: 'Tous ceux qui sont sur le tableau. La couleur de chacun se retrouve partout.',
            membersAdd: 'Personne',
            membersAddLong: 'Ajouter une personne',
            membersNew: 'Nouvelle personne',
            namePlaceholder: 'Par exemple Noor',
            face: 'Pictogramme',
            kidLockTitle: 'Verrou de la tablette',
            kidLockBody: 'Un code PIN avant que quelqu’un coche quelque chose sur la tablette. Désactivé par défaut.',
            exportAll: 'Tout le monde',
            devicesIntro: 'Les tablettes sur lesquelles tourne votre tableau.',
            library: 'Idées de tâches',
            libraryIntro: 'Choisis une tâche et pour qui.',
            wizardMembersTitle: 'Qui habite ici ?',
            wizardMembersBody: 'Donne à chacun sa couleur. Tu la retrouveras partout.',
            noTasksTitle: 'Aucune tâche aujourd’hui',
            noTasksBody: 'Tout est à jour.',
            tasksWidget: 'Tâches du jour',
            tasksAll: 'Toutes les tâches',
            tasksEmptyBody: 'Commence par quelque chose de simple, comme le linge ou arroser les plantes.',
            exportBody: 'Télécharge l’agenda en fichier .ics, pour tout le monde ou par personne.',
            dataBody: 'Une copie de vos données en fichier (JSON), y compris les choix dans {profile}. Tu confirmes d’abord avec ton mot de passe.',
            dataAll: 'Tout',
            privacyEntryBody: 'Tout télécharger, retirer quelqu’un ou supprimer le tableau.',
            approvalHint: 'Quelqu’un d’autre vérifie la tâche avant qu’elle compte comme faite.',
            supportIntro: 'Besoin d’aide ? AMUMIN peut regarder avec vous un moment, en lecture seule. Vous décidez de la durée, et chaque administrateur peut l’arrêter tout de suite.',
            supportOff: 'Désactivé. Personne chez AMUMIN ne peut voir votre tableau.',
            supportSees: 'AMUMIN voit alors : les noms de tous ceux qui sont sur le tableau, les titres des rendez-vous d’aujourd’hui et des 6 jours suivants (un titre peut contenir quelque chose comme Dentiste ; les rendez-vous avec un pictogramme religieux comme mosquée ou église non), les pièces et les tablettes. Pas : la religion, la santé, l’école, les adresses e-mail ou les photos. Chaque consultation apparaît ci-dessous.',
        },
        solo: {
            membersTitle: 'Qui en fait partie',
            membersIntro: 'Toi, et ceux que tu ajoutes plus tard. Ta couleur se retrouve partout.',
            membersAdd: 'Personne',
            membersAddLong: 'Ajouter une personne',
            membersNew: 'Nouvelle personne',
            namePlaceholder: 'Par exemple Noor',
            face: 'Pictogramme',
            kidLockTitle: 'Verrou de la tablette',
            kidLockBody: 'Un code PIN avant que quelqu’un coche quelque chose sur la tablette. Désactivé par défaut.',
            exportAll: 'Tout',
            devicesIntro: 'Les tablettes sur lesquelles tourne ton tableau.',
            library: 'Idées de tâches',
            libraryIntro: 'Choisis une tâche que tu fais souvent.',
            wizardMembersTitle: 'Quelqu’un d’autre ?',
            wizardMembersBody: 'Tu es déjà sur le tableau. Quelqu’un d’autre en fait partie, par exemple pour des rendez-vous communs ? Ajoute cette personne ici ou plus tard.',
            noTasksTitle: 'Aucune tâche aujourd’hui',
            noTasksBody: 'Tout est à jour.',
            tasksWidget: 'Tâches du jour',
            tasksAll: 'Toutes les tâches',
            tasksEmptyBody: 'Commence par quelque chose de simple, comme le linge ou arroser les plantes.',
            exportBody: 'Télécharge l’agenda en fichier .ics, pour tout le monde ou par personne.',
            dataBody: 'Une copie de vos données en fichier (JSON), y compris les choix dans {profile}. Tu confirmes d’abord avec ton mot de passe.',
            dataAll: 'Tout',
            privacyEntryBody: 'Tout télécharger, retirer quelqu’un ou supprimer le tableau.',
            approvalHint: 'Vous vérifiez la tâche vous-même avant qu’elle compte comme faite.',
            supportIntro: 'Besoin d’aide ? AMUMIN peut regarder avec vous un moment, en lecture seule. Vous décidez de la durée, et vous pouvez l’arrêter tout de suite.',
            supportOff: 'Désactivé. Personne chez AMUMIN ne peut voir votre tableau.',
            supportSees: 'AMUMIN voit alors : les noms de tous ceux qui sont sur le tableau, les titres des rendez-vous d’aujourd’hui et des 6 jours suivants (un titre peut contenir quelque chose comme Dentiste ; les rendez-vous avec un pictogramme religieux comme mosquée ou église non), les pièces et les tablettes. Pas : la religion, la santé, l’école, les adresses e-mail ou les photos. Chaque consultation apparaît ci-dessous.',
        },
        shared: {
            membersTitle: 'Colocataires',
            membersIntro: 'Tous ceux qui habitent la maison. La couleur de chacun se retrouve partout.',
            membersAdd: 'Colocataire',
            membersAddLong: 'Ajouter un colocataire',
            membersNew: 'Nouveau colocataire',
            namePlaceholder: 'Par exemple Sanne',
            face: 'Pictogramme',
            kidLockTitle: 'Verrou de la tablette',
            kidLockBody: 'Un code PIN avant que quelqu’un coche quelque chose sur la tablette du couloir. Désactivé par défaut.',
            exportAll: 'Toute la maison',
            devicesIntro: 'Les tablettes sur lesquelles tourne le tableau de la maison.',
            library: 'Idées de tâches',
            libraryIntro: 'Choisis une tâche et qui la fait.',
            wizardMembersTitle: 'Qui habite ici ?',
            wizardMembersBody: 'Qui habite dans la maison ? Tu pourras plus tard donner à chacun son propre accès.',
            noTasksTitle: 'Aucune tâche aujourd’hui',
            noTasksBody: 'Regarde le planning pour savoir qui fait quoi.',
            tasksWidget: 'Tâches du jour',
            tasksAll: 'Toutes les tâches',
            tasksEmptyBody: 'Commence par quelque chose de simple, comme sortir les poubelles.',
            exportBody: 'Télécharge l’agenda en fichier .ics, pour tout le monde ou par personne.',
            dataBody: 'Une copie de vos données en fichier (JSON), y compris les choix dans {profile}. Tu confirmes d’abord avec ton mot de passe.',
            dataAll: 'Toute la maison',
            privacyEntryBody: 'Tout télécharger, retirer quelqu’un ou supprimer le tableau.',
            approvalHint: 'Un colocataire vérifie la tâche avant qu’elle compte comme faite.',
            supportIntro: 'Besoin d’aide ? AMUMIN peut regarder avec vous un moment, en lecture seule. Vous décidez de la durée, et chaque administrateur de la maison peut l’arrêter tout de suite.',
            supportOff: 'Désactivé. Personne chez AMUMIN ne peut voir le tableau de votre maison.',
            supportSees: 'AMUMIN voit alors : les noms de tous ceux qui sont sur le tableau, les titres des rendez-vous d’aujourd’hui et des 6 jours suivants (un titre peut contenir quelque chose comme Dentiste ; les rendez-vous avec un pictogramme religieux comme mosquée ou église non), les pièces et les tablettes. Pas : la religion, la santé, l’école, les adresses e-mail ou les photos. Chaque consultation apparaît ci-dessous.',
        },
        care: {
            membersTitle: 'Famille',
            membersIntro: 'Tous ceux qui aident ou sont sur le tableau. La couleur de chacun se retrouve partout.',
            membersAdd: 'Personne',
            membersAddLong: 'Ajouter une personne',
            membersNew: 'Nouvelle personne',
            namePlaceholder: 'Par exemple Anja',
            face: 'Pictogramme',
            kidLockTitle: 'Verrou de la tablette',
            kidLockBody: 'Un code PIN avant que quelqu’un coche quelque chose sur la tablette. Désactivé par défaut.',
            exportAll: 'Tout le monde',
            devicesIntro: 'Les tablettes sur lesquelles tourne le tableau.',
            library: 'Idées de tâches',
            libraryIntro: 'Choisis une tâche et pour qui.',
            wizardMembersTitle: 'Qui aide ?',
            wizardMembersBody: 'Ajoute tous ceux qui aident ou doivent être sur le tableau. Chacun reçoit sa propre couleur.',
            noTasksTitle: 'Aucune tâche aujourd’hui',
            noTasksBody: 'Tout est à jour.',
            tasksWidget: 'Tâches du jour',
            tasksAll: 'Toutes les tâches',
            tasksEmptyBody: 'Commence par quelque chose de simple, comme les médicaments ou les courses.',
            exportBody: 'Télécharge l’agenda en fichier .ics, pour tout le monde ou par personne.',
            dataBody: 'Une copie de vos données en fichier (JSON), y compris les choix dans {profile}. Tu confirmes d’abord avec ton mot de passe.',
            dataAll: 'Tout',
            privacyEntryBody: 'Tout télécharger, retirer quelqu’un ou supprimer le tableau.',
            approvalHint: 'Un administrateur vérifie la tâche avant qu’elle compte comme faite.',
            supportIntro: 'Besoin d’aide ? AMUMIN peut regarder avec vous un moment, en lecture seule. Vous décidez de la durée, et chaque administrateur peut l’arrêter tout de suite.',
            supportOff: 'Désactivé. Personne chez AMUMIN ne peut voir votre tableau.',
            supportSees: 'AMUMIN voit alors : les noms de tous ceux qui sont sur le tableau, les titres des rendez-vous d’aujourd’hui et des 6 jours suivants (un titre peut contenir quelque chose comme Dentiste ; les rendez-vous avec un pictogramme religieux comme mosquée ou église non), les pièces et les tablettes. Pas : la religion, la santé, l’école, les adresses e-mail ou les photos. Chaque consultation apparaît ci-dessous.',
        },
    },
    rotation: {
        title: 'Planning des tâches',
        intro: 'Les tâches tournent équitablement : celui dont c’était le tour passe en fin de file. Qui est absent saute un tour, puis repasse en premier.',
        thisWeek: 'Cette semaine',
        today: 'Aujourd’hui',
        nextUp: 'Ensuite',
        weekOf: 'semaine du {date}',
        nobody: 'Personne ne participe',
        done: 'Fait par {name}',
        notYet: 'Pas encore fait',
        swapped: 'Échangé',
        skipped: '{name} est absent',
        swap: 'Échanger',
        swapTitle: 'Qui fait {duty} {period} ?',
        swapPeriodWeek: 'cette semaine',
        swapPeriodDay: 'aujourd’hui',
        swapUndo: 'Annuler l’échange',
        swapSaved: '{name} fait {duty}',
        swapRemoved: 'L’échange a été annulé',
        away: 'Absent',
        awayTitle: 'Quelqu’un est absent un moment',
        awayBody: 'En vacances ou en déplacement ? La personne saute un tour, puis repasse en premier.',
        awayWho: 'Qui',
        awayFrom: 'Du',
        awayTo: 'Jusqu’au (inclus)',
        awayAdd: 'Marquer absent',
        awayRemove: 'De retour',
        awayItem: '{name} : du {from} au {to}',
        awaySaved: '{name} est marqué absent',
        awayRemoved: '{name} est de retour',
        awayInvalid: 'La date de fin est avant la date de début.',
        empty: 'Pas encore de planning',
        emptyBody: 'Crée un planning avec cuisine, salle de bain, couloir, poubelles, vaisselle et repas. Ensuite, tu peux retirer ou ajouter des tâches dans Ménage.',
        setup: 'Créer le planning',
        setupDone: '{count} tâches sont dans le planning',
        setupNothing: 'Ces tâches sont déjà dans le planning',
        weekly: 'Chaque semaine',
        daily: 'Chaque jour',
        others: 'Autres tâches',
        othersBody: 'Tâches de Ménage qui ne tournent pas encore.',
        makeWeekly: 'Tourner chaque semaine',
        makeDaily: 'Tourner chaque jour',
        stopRotating: 'Ne plus tourner',
        rotatingOn: '{duty} tourne maintenant',
        rotatingOff: '{duty} ne tourne plus',
        onBoard: 'L’écran de l’entrée montre à qui c’est le tour cette semaine. On coche là-bas d’un simple toucher.',
        duties: {
            kitchen: 'Cuisine',
            bathroom: 'Salle de bain',
            hallway: 'Couloir et escalier',
            trash: 'Poubelles',
            dishes: 'Vaisselle',
            cooking: 'Repas',
        },
    },
};
//# sourceMappingURL=householdsApp.fr.js.map